// import "babel-polyfill"
// require('es6-promise').polyfill();
// require('es6-promise/auto');
import Vue from 'vue'

import './init.js'
import { amountFormat, formatAmount } from '@/utils/common.js'

import Cookies from 'js-cookie'

import 'normalize.css/normalize.css'

import Element from 'element-ui'
//
import mavonEditor from 'mavon-editor'
import 'mavon-editor/dist/css/index.css'

// 数据字典
import dict from './components/Dict'

// 权限指令
import permission from './components/Permission'
import checkPermission from '@/utils/permission.js'
import './assets/styles/element-variables.scss'
// global css
import './assets/styles/index.scss'

// 代码高亮
// import VueHighlightJS from 'vue-highlightjs'
// import 'highlight.js/styles/atom-one-dark.css'

import App from './App'
import store from './store'
import router from './router/routers'

import './assets/icons' // icon
import './router/index' // permission control
// import vueHighlightJS from 'vue-highlightjs'
import sheetExporter from './components/SheetExporter/index.js'
import elTableInfiniteScroll from 'el-table-infinite-scroll'
Vue.use(elTableInfiniteScroll)

import Decimal from 'decimal.js'
Vue.prototype.$Decimal = Decimal

// 日期处理
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn' // 中文本地化
// 可选：安装插件（如需要）
import advancedFormat from 'dayjs/plugin/advancedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
// 使用插件
dayjs.extend(advancedFormat)
dayjs.extend(relativeTime)
dayjs.locale('zh-cn') // 设置默认语言
// 挂载到 Vue 原型
Vue.prototype.$dayjs = dayjs

// Vue.use(VueHighlightJS)
Vue.use(mavonEditor)
Vue.use(permission)
Vue.use(dict)
Vue.use(Element, {
  size: Cookies.get('size') || 'small' // set element-ui default size
})

Element.Dialog.props.top = {
  type: String,
  default: '10vh'
}

Vue.config.productionTip = false
Vue.mixin({// 判断平台
  // 指令v-focus: 使input输入框自动获取焦点,解决autofocus失效问题
  directives: {
    focus: {
      inserted: function(el) {
        el.querySelector('input').focus()
      }
    },
    // 指令v-noSpace: 禁止输入空格（兼容中文输入法，组合输入期间不得改写 value）
    noSpace: {
      inserted(el) {
        const input = el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' ? el : el.querySelector('input, textarea')
        if (!input) return
        // composing: 输入法组合中（拼音未上屏）；syncing: 正在派发合成事件，避免重复处理
        let composing = false
        let syncing = false
        const format = (target) => {
          const raw = target.value
          const value = raw.replace(/\s+/g, '')
          if (value === raw) return
          // 记录光标前被删除的空格数，赋值后还原光标，否则光标会跳到末尾（Safari 尤其明显）
          const start = target.selectionStart || 0
          const removed = raw.slice(0, start).length - raw.slice(0, start).replace(/\s+/g, '').length
          target.value = value
          const pos = Math.max(0, start - removed)
          try {
            target.setSelectionRange(pos, pos)
          } catch (err) {
            // 部分输入类型（如 number/email）不支持设置选区，忽略即可
          }
          // 派发冒泡的 input 事件同步 v-model
          syncing = true
          target.dispatchEvent(new Event('input', { bubbles: true }))
          syncing = false
        }
        input.addEventListener('compositionstart', () => {
          composing = true
        })
        input.addEventListener('compositionend', (e) => {
          // 拼音上屏后再清理空格
          composing = false
          format(e.target)
        })
        input.addEventListener('input', (e) => {
          if (syncing || composing || e.isComposing) return
          format(e.target)
        })
      }
    }
  },
  filters: {
    amountFormat
  },
  data() {
    return {
      isAdminSystem: false,
      footerTxt: ''
    }
  },
  mounted() {
    // if (window.location.href.indexOf('//om.') > -1) {
    //   //document.title=
    // } else {
    //   this.isAdminSystem = false
    // }

    if (window.location.href.indexOf('//om.') > -1) {
      document.title = '业务管理平台'
    } else if (window.location.href.indexOf('//saas.') > -1) {
      document.title = '机构管理平台'
    } else {
      document.title = '多元化用工数字管理平台'
    }
  },
  methods: {
    formatAmount,
    checkPermission,
    // 获取当前网页的协议+域名
    getPageBaseUrl() {
      // 如果是开发环境直接返回https://www.test.taxll.com
      if (process.env.NODE_ENV === 'development') {
        return 'https://www.test.taxll.com'
      }
      let baseURL = ''
      if (!window.location.origin) { // 兼容IE，IE11版本下location.origin为undefined
        window.location.origin = window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
      } else {
        baseURL = window.location.origin
      }
      return baseURL
    }
  }
})
Vue.prototype.$bus = new Vue()
Vue.prototype.$sheetExporter = sheetExporter
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
